import axios from 'axios';

export default {
    fetch() {
        return axios.get(window.API_BASE + '/context');
    }
}